import logger from "./logger";

/**
 * Gets the user role from localStorage authUser
 * @returns The user role string or undefined if not found
 */
export const getUserRole = (): string | undefined => {
  const raw = localStorage.getItem("authUser");
  if (!raw) return undefined;

  try {
    const user = JSON.parse(raw) as { role?: string };
    return user.role;
  } catch {
    logger.error("invalid authUser in localStorage");
    return undefined;
  }
};

/**
 * Checks if the current user has the "DEV" role
 * @returns true if user role is "DEV", false otherwise
 */
export const isDevRole = (): boolean => {
  const role = getUserRole();
  return role === "DEV";
};

/**
 * Checks if the current user has the "SUPERADMIN" role
 * @returns true if user role is "SUPERADMIN", false otherwise
 */
export const isSuperAdminRole = (): boolean => {
  const role = getUserRole();
  return role === "SUPERADMIN";
};
